import React from 'react';
import { midas } from '@resurs/midas';
import { Slide, toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const iconElement = (iconClassName) => (React.createElement("i", { style: {
        display: 'flex',
        alignItems: 'center',
    }, className: iconClassName }));
const triggerToast = (kind, message, args) => {
    if (kind === 'primary') {
        toast.info(message, {
            className: midas.toastPrimary,
            icon: iconElement(midas.midasInformation),
            ...args,
        });
    }
    else if (kind === 'warning') {
        toast.warning(message, {
            className: midas.toastWarning,
            icon: iconElement(midas.midasAlert1),
            ...args,
        });
    }
    else if (kind === 'success') {
        toast.success(message, {
            className: midas.toastSuccess,
            icon: iconElement(midas.midasCheckCircle2),
            ...args,
        });
    }
    else if (kind === 'danger') {
        toast.error(message, {
            className: midas.toastDanger,
            icon: iconElement(midas.midasAlert2),
            ...args,
        });
    }
};
export const triggerPrimaryToast = (message, args) => {
    triggerToast('primary', message, args);
};
export const triggerSuccessToast = (message, args) => {
    triggerToast('success', message, args);
};
export const triggerWarningToast = (message, args) => {
    triggerToast('warning', message, args);
};
export const triggerDangerToast = (message, args) => {
    triggerToast('danger', message, args);
};
const Toast = ({ timeout = 4000, dataTestId, toastContainerStyles, }) => (React.createElement("div", { "data-testid": dataTestId },
    React.createElement(ToastContainer, { style: toastContainerStyles, className: midas.toast, toastClassName: midas.toast, bodyClassName: midas.toastBody, theme: "colored", transition: Slide, autoClose: timeout, pauseOnFocusLoss: true, draggable: true, pauseOnHover: true, closeOnClick: false })));
export default Toast;
